import store from '../store/index'
import vue from 'vue'
export default (to, from, next) => {
  if (store.getters.userDetails.includes(to.meta.permission)) {
    next()
  } else {
    vue.swal("Info", "User permission denied", "warning")
    next(false)
  }
}